<template>
  <div id="app">
      <!-- <div class="d-header">Levels of Processing</div>
      <progress class="d-progress" :value="progressCnt" :max="progressMax"></progress> -->
      <div class="d-cont">
          <div class="d-header">Levels of Processing</div>
          <progress class="d-progress" :value="progressCnt" :max="progressMax"></progress>
          <div class="body">
                <div v-if="showDBox" class="d-box">
                    <div class="body">
                        <div class="content" v-if="progressCnt == 0 || progressCnt == 10">
                            <h1 v-if="progressCnt == 0">Levels of Processing</h1>
                            
                            <div v-if="progressCnt == 10"><h3>You have completed this exercise</h3><br>Thank you for participating</div>
                        </div>
                        <div class="content" v-if="progressCnt == 2">
                            <p class="text-left">Below are some target words. Click on each target word that is in capital letters, and then click NEXT.</p>
                            <div class="row">
                                <div class="col-md-4 mt-3" @click="firstClick1 = !firstClick1"> <span :class="firstClick1 ? 'active' : ''">memory</span> </div>
                                <div class="col-md-4 mt-3" @click="firstClick2 = !firstClick2"> <span :class="firstClick2 ? 'active' : ''">THROUGH</span> </div>
                                <div class="col-md-4 mt-3" @click="firstClick3 = !firstClick3"> <span :class="firstClick3 ? 'active' : ''">FLOWER</span> </div>
                                <div class="col-md-4 mt-3" @click="firstClick4 = !firstClick4"> <span :class="firstClick4 ? 'active' : ''">mine</span> </div>
                                <div class="col-md-4 mt-3" @click="firstClick5 = !firstClick5"> <span :class="firstClick5 ? 'active' : ''">seem</span> </div>
                                <div class="col-md-4 mt-3" @click="firstClick6 = !firstClick6"> <span :class="firstClick6 ? 'active' : ''">FILTER</span> </div>
                            </div>
                        </div>
                        <div class="content" v-if="progressCnt == 3">
                            <p class="text-left">Now type the identified target words in the text boxes below, and then click NEXT.</p>
                            <div><input type="text" class="my-textbox mt-3" v-model="firstTextbox[0]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="firstTextbox[1]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="firstTextbox[2]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="firstTextbox[3]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="firstTextbox[4]"> </div>
                            <div><input type="text" class="my-textbox mt-3 mb-3" v-model="firstTextbox[5]"> </div>
                        </div>
                        <div class="content" v-if="progressCnt == 4">
                            <p class="text-left">Below are some target words. Click on each target word that rhymes with “beam”, and then click NEXT.</p>
                            <div class="row">
                                <div class="col-md-4 mt-3" @click="secondClick1 = !secondClick1"> <span :class="secondClick1 ? 'active' : ''">times</span> </div>
                                <div class="col-md-4 mt-3" @click="secondClick2 = !secondClick2"> <span :class="secondClick2 ? 'active' : ''">stream</span> </div>
                                <div class="col-md-4 mt-3" @click="secondClick3 = !secondClick3"> <span :class="secondClick3 ? 'active' : ''">pages</span> </div>
                                <div class="col-md-4 mt-3" @click="secondClick4 = !secondClick4"> <span :class="secondClick4 ? 'active' : ''">cream</span> </div>
                                <div class="col-md-4 mt-3" @click="secondClick5 = !secondClick5"> <span :class="secondClick5 ? 'active' : ''">gleam</span> </div>
                                <div class="col-md-4 mt-3" @click="secondClick6 = !secondClick6"> <span :class="secondClick6 ? 'active' : ''">faces</span> </div>
                            </div>
                        </div>
                        <div class="content" v-if="progressCnt == 5">
                            <p class="text-left">Now type the identified target words in the text boxes below, and then click NEXT.</p>
                            <div><input type="text" class="my-textbox mt-3" v-model="secondTextbox[0]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="secondTextbox[1]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="secondTextbox[2]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="secondTextbox[3]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="secondTextbox[4]"> </div>
                            <div><input type="text" class="my-textbox mt-3 mb-3" v-model="secondTextbox[5]"> </div>
                        </div>
                        <div class="content" v-if="progressCnt == 6">
                            <p class="text-left">Click on each target word that would make sentence in the following sentence:</p>
                            <p class="text-left">“They saw a _____ in the street.”</p>
                            <div class="row">
                                <div class="col-md-4 mt-3" @click="thirdClick1 = !thirdClick1"> <span :class="thirdClick1 ? 'active' : ''">lorry</span> </div>
                                <div class="col-md-4 mt-3" @click="thirdClick2 = !thirdClick2"> <span :class="thirdClick2 ? 'active' : ''">when</span> </div>
                                <div class="col-md-4 mt-3" @click="thirdClick3 = !thirdClick3"> <span :class="thirdClick3 ? 'active' : ''">woman</span> </div>
                                <div class="col-md-4 mt-3" @click="thirdClick4 = !thirdClick4"> <span :class="thirdClick4 ? 'active' : ''">friend</span> </div>
                                <div class="col-md-4 mt-3" @click="thirdClick5 = !thirdClick5"> <span :class="thirdClick5 ? 'active' : ''">other</span> </div>
                                <div class="col-md-4 mt-3" @click="thirdClick6 = !thirdClick6"> <span :class="thirdClick6 ? 'active' : ''">weeks</span> </div>
                            </div>
                        </div>
                        <div class="content" v-if="progressCnt == 7">
                            <p class="text-left">Now type the identified target words in the text boxes below, and then click NEXT.</p>
                            <div><input type="text" class="my-textbox mt-3" v-model="thirdTextbox[0]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="thirdTextbox[1]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="thirdTextbox[2]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="thirdTextbox[3]"> </div>
                            <div><input type="text" class="my-textbox mt-3" v-model="thirdTextbox[4]"> </div>
                            <div><input type="text" class="my-textbox mt-3 mb-3" v-model="thirdTextbox[5]"> </div>
                        </div>
                        <div class="content" v-if="progressCnt == 8">
                          <div class="row">
                              <div class="col-md-6 text-left">
                                  <p>The first task, <em>Click on each word that is in capital letters</em> is a <strong>shallow task</strong> and you were expected to remember few of the words shown.</p>
                              </div>
                              <div class="col-md-6">
                                  <div>
                                    <bar-chart :chartData="datacollection" :maxScore="maxScore" :height="350"></bar-chart>
                                  </div>
                              </div>
                              <div class="col-md-12">
                                  <p class="text-left">The second task, <em>Click on the words that rhyme with “beam”</em>, involves <strong>processing phonemes</strong> and is not as much of a shallow task as the previous one. You were therefore expected to recall more words in comparison to the shallow task.</p>
                                  <p class="text-left">The third task, <em>Click on those words that would make sense in the sentence: “They saw a _________ in the street”</em>, is a <strong>deep task</strong> since it involved you processing the meaning of the words. You were expected to remember more of these words than in the shallow and phoneme tasks.</p>
                                  <p class="text-left">Craik and Tulving (1975) found that the deeper the processing, the more words that were remembered in the later test.</p>
                              </div>
                          </div>

                        </div>
                        <div class="content" v-if="progressCnt == 9">
                            <p class="text-left" style="font-size: 1.13rem;font-weight:bold;">Levels of Processing: Strengths and Weaknesses</p>
                            <p class="text-left"><strong>Strengths</strong></p>
                            <ol>
                              <li class="text-left">This approach shows that learning involves much more than just rehearsal. It can be dependent upon the depth of the 
                                  <draggable
                                        :list="ans1"
                                        class="ans-drag"
                                        group="choices"
                                        @change="dragChange"
                                    >
                                        <div
                                        class="list-ans1-drag" >
                                        {{ ans1[0] }}
                                        </div>
                                    </draggable>.
                              </li>
                              <li class="text-left">Much 
                                    <draggable
                                        :list="ans2"
                                        class="ans-drag"
                                        group="choices"
                                        @change="dragChange"
                                    >
                                        <div
                                        class="list-ans1-drag" >
                                        {{ ans2[0] }}
                                        </div>
                                    </draggable>
                                    was inspired by this approach.
                              </li>
                            </ol>
                            <p class="text-left"><strong>Weaknesses</strong></p>
                            <ol>
                              <li class="text-left">The main problem with the levels of processing approach, according to Baddeley (1978) is that it is 
                                    <draggable
                                        :list="ans3"
                                        class="ans-drag"
                                        group="choices"
                                        @change="dragChange"
                                    >
                                        <div
                                        class="list-ans1-drag" >
                                        {{ ans3[0] }}
                                        </div>
                                    </draggable>
                                    . How can we measure the depth of processing? There appears to be no independent index of ‘depth’. We can only say that if a stimulus is remembered it must have been processed to a deep level – we cannot say in advance whether a certain type of stimulus will lead to a better
                                    <draggable
                                        :list="ans4"
                                        class="ans-drag"
                                        group="choices"
                                        @change="dragChange"
                                    >
                                        <div
                                        class="list-ans1-drag" >
                                        {{ ans4[0] }}
                                        </div>
                                    </draggable>
                                    .
                              </li>
                            </ol>
                            <draggable
                                :list="choices"
                                class="dragChoice row"
                                group="choices"
                            >
                                <div class="col-md-6 mb-1 mt-1" v-for="(choice, index) in choices" :key="index" >
                                  <span>{{ choice }}</span>
                                </div>
                            </draggable>
                            
                        </div>

                        <div class="footer">
                            <div v-if="showError && correct < 4" class="errorShow text-danger"> You have got {{correct}} out of 4 correct, keep trying until have all 4 correct </div>
                            <div v-if="showError && correct == 4" class="successShow text-success"> You have got {{correct}} out of 4 correct, click NEXT to continue </div>
                            <button class="btn" @click="btnBox">{{boxBtnText}}</button>
                        </div>
                    </div>
                </div>
                <div v-if="showDGame" class="d-game">
                  <div class="body" v-if="progressCnt == 1">
                      <div class="header">Levels of Processing</div>
                      <div class="target">
                          <p>Craik and Lockhart (1972) suggested that it is not rehearsal that determines how well we remember something, but how deeply it is analysed.</p>
                          <p>If information is processed in a very shallow way, then little learning will occur. Information that is processed in a deep way is more likely to be remembered.</p>
                      </div>
                      <div class="footer">
                          <button class="btn btn-target" @click="btnGame">NEXT</button>
                      </div>
                  </div>
                </div>
          </div>
      </div>
  </div>
</template>

<script>

import JQuery from 'jquery';
import BarChart from './Chart.vue';
import draggable from 'vuedraggable';

let $ = JQuery;

export default {
  name: "app",
  components: { BarChart, draggable },
  data() {
    return {
      progressCnt: 0,
      progressMax: 10,
      showDBox: true,
      showDGame: false,
      boxBtnText: 'START',
      firstClick1: false,
      firstClick2: false,
      firstClick3: false,
      firstClick4: false,
      firstClick5: false,
      firstClick6: false,
      firstTextbox: ['','','','','',''],
      secondClick1: false,
      secondClick2: false,
      secondClick3: false,
      secondClick4: false,
      secondClick5: false,
      secondClick6: false,
      secondTextbox: ['','','','','',''],
      thirdClick1: false,
      thirdClick2: false,
      thirdClick3: false,
      thirdClick4: false,
      thirdClick5: false,
      thirdClick6: false,
      thirdTextbox: ['','','','','',''],
      datacollection: null,
      maxScore: 100,
      ans1: [],
      ans2: [],
      ans3: [],
      ans4: [],
      choices: ['circular','processing','memory','research'],
      showError: false,
      correct: 0,
    }
  },
  mounted() {
    this._box();
  },
  methods: {
    _box() {
        $(document).ready(function(){
          var p = this;
          var main = $(".d-cont");
          main.removeClass("d-scroll");
          var box = $(".d-box");
          if (main.outerHeight() <= (box.outerHeight() + 40 + 80) || main.outerWidth() <= (box.outerWidth() + 40 + 80)){
              main.addClass("d-scroll");
          }else{
              main.removeClass("d-scroll");
          }
        });
    },
    checkScore(){
        var cnt = 0;
          var score = 4;
            if(this.ans1.length == 0 || (this.ans1.length > 0 && this.ans1[0] != 'processing')){
                this.showError = true;
                score--;
                cnt++;
            }
            if(this.ans2.length == 0 || (this.ans2.length > 0 && this.ans2[0] != 'research')){
                this.showError = true;
                score--;
                cnt++;
            }
            if(this.ans3.length == 0 || (this.ans3.length > 0 && this.ans3[0] != 'circular')){
                this.showError = true;
                score--;
                cnt++;
            } 
            if(this.ans4.length == 0 || (this.ans4.length > 0 && this.ans4[0] != 'memory')){
                this.showError = true;
                score--;
                cnt++;
            }
            if(cnt>=0){
                this.correct = score;
                return false;
            }
    },
    btnBox() {
        if(this.progressCnt == 9 && this.correct < 4){
            this.showError = true;
            return false;
        }

        $(document).ready(function(){
            $('.d-scroll').scrollTop(0);
        });
        this.progressCnt++;
        this.showError = false;

        switch (this.progressCnt) {
          case 1:
                this.showDBox = false;
                this.showDGame = true;
            break;
          case 8:
                this.fillData();
            break;
          case 10:
                this.boxBtnText = 'TRY AGAIN';
            break;
          case 11:
                this.progressCnt = 0
                this.showDBox = true
                this.showDGame = false
                this.boxBtnText = 'START'
                this.firstClick1 = false
                this.firstClick2 = false
                this.firstClick3 = false
                this.firstClick4 = false
                this.firstClick5 = false
                this.firstClick6 = false
                this.firstTextbox = ['','','','','','']
                this.secondClick1 = false
                this.secondClick2 = false
                this.secondClick3 = false
                this.secondClick4 = false
                this.secondClick5 = false
                this.secondClick6 = false
                this.secondTextbox = ['','','','','','']
                this.thirdClick1 = false
                this.thirdClick2 = false
                this.thirdClick3 = false
                this.thirdClick4 = false
                this.thirdClick5 = false
                this.thirdClick6 = false
                this.thirdTextbox = ['','','','','','']
                this.datacollection = null
                this.maxScore = 100
                this.ans1 = []
                this.ans2 = []
                this.ans3 = []
                this.ans4 = []
                this.choices = ['circular','processing','memory','research']
                this.showError = false
                this.correct = 0
            break;

          default:
            break;
        }
    },
    btnGame() {
        $(document).ready(function(){
            $('.d-scroll').scrollTop(0);
        });
        this.progressCnt++;
        this.boxBtnText = 'NEXT';
        this.showDBox = true;
        this.showDGame = false;
    },
    fillData () {
      var taskScore = [0,0,0];


      taskScore[0] += this.firstTextbox.indexOf('MEMORY') > -1 || this.firstTextbox.indexOf('memory') > -1 ? 1 : 0;
      taskScore[0] += this.firstTextbox.indexOf('THROUGH') > -1 || this.firstTextbox.indexOf('through') > -1 ? 1 : 0;
      taskScore[0] += this.firstTextbox.indexOf('FLOWER') > -1 || this.firstTextbox.indexOf('flower') > -1 ? 1 : 0;
      taskScore[0] += this.firstTextbox.indexOf('MINE') > -1 || this.firstTextbox.indexOf('mine') > -1 ? 1 : 0;
      taskScore[0] += this.firstTextbox.indexOf('SEEM') > -1 || this.firstTextbox.indexOf('seem') > -1 ? 1 : 0;
      taskScore[0] += this.firstTextbox.indexOf('FILTER') > -1 || this.firstTextbox.indexOf('filter') > -1 ? 1 : 0;

      taskScore[1] += this.secondTextbox.indexOf('TIMES') > -1 || this.secondTextbox.indexOf('times') > -1 ? 1 : 0;
      taskScore[1] += this.secondTextbox.indexOf('STREAM') > -1 || this.secondTextbox.indexOf('stream') > -1 ? 1 : 0;
      taskScore[1] += this.secondTextbox.indexOf('PAGES') > -1 || this.secondTextbox.indexOf('pages') > -1 ? 1 : 0;
      taskScore[1] += this.secondTextbox.indexOf('CREAM') > -1 || this.secondTextbox.indexOf('cream') > -1 ? 1 : 0;
      taskScore[1] += this.secondTextbox.indexOf('GLEAM') > -1 || this.secondTextbox.indexOf('gleam') > -1 ? 1 : 0;
      taskScore[1] += this.secondTextbox.indexOf('FACES') > -1 || this.secondTextbox.indexOf('faces') > -1 ? 1 : 0;

      taskScore[2] += this.thirdTextbox.indexOf('LORRY') > -1 || this.thirdTextbox.indexOf('lorry') > -1 ? 1 : 0;
      taskScore[2] += this.thirdTextbox.indexOf('WHEN') > -1 || this.thirdTextbox.indexOf('when') > -1 ? 1 : 0;
      taskScore[2] += this.thirdTextbox.indexOf('WOMAN') > -1 || this.thirdTextbox.indexOf('woman') > -1 ? 1 : 0;
      taskScore[2] += this.thirdTextbox.indexOf('FRIEND') > -1 || this.thirdTextbox.indexOf('friend') > -1 ? 1 : 0;
      taskScore[2] += this.thirdTextbox.indexOf('OTHER') > -1 || this.thirdTextbox.indexOf('other') > -1 ? 1 : 0;
      taskScore[2] += this.thirdTextbox.indexOf('WEEKS') > -1 || this.thirdTextbox.indexOf('weeks') > -1 ? 1 : 0;

      this.datacollection = {
        labels: ['Shallow', '', 'Deep'],
        datasets: [
          {
            label: 'Task',
            backgroundColor: '#a2a2a2',
            data: taskScore
          }
        ]
      }
    },
    dragChange(e) {
        if(e.added == undefined){
            return false;
        }
        var added =  e.added.element;
    
        if(this.ans1.indexOf(added) > -1 && this.ans1.length > 1) {
            if(this.ans1.indexOf(added) == 0){
                this.choices.push(this.ans1[1]);
                this.ans1.splice(1, 1);
            }else{
                this.choices.push(this.ans1[0]);
                this.ans1.splice(0, 1);
            }
        }else if(this.ans2.indexOf(added) > -1 && this.ans2.length > 1) {
            if(this.ans2.indexOf(added) == 0){
                this.choices.push(this.ans2[1]);
                this.ans2.splice(1, 1);
            }else{
                this.choices.push(this.ans2[0]);
                this.ans2.splice(0, 1);
            }
        }else if(this.ans3.indexOf(added) > -1 && this.ans3.length > 1) {
            if(this.ans3.indexOf(added) == 0){
                this.choices.push(this.ans3[1]);
                this.ans3.splice(1, 1);
            }else{
                this.choices.push(this.ans3[0]);
                this.ans3.splice(0, 1);
            }
        }else if(this.ans4.indexOf(added) > -1 && this.ans4.length > 1) {
            if(this.ans4.indexOf(added) == 0){
                this.choices.push(this.ans4[1]);
                this.ans4.splice(1, 1);
            }else{
                this.choices.push(this.ans4[0]);
                this.ans4.splice(0, 1);
            }
        }

        this.checkScore();
    }
  },
};
</script>

<style>
html,body{
    padding:0px;
    margin:0px;
    height:100%;
    width:100%;
    overflow:hidden;
    font-size:20px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
}
body{
    color:black;
}

.d-cont{
    
    width: 100%;
    height: 100%;
    /* max-width: 1200px;
    max-height: 800px; */
    position: absolute;
    transform: translate(-50%,-50%);
    left: 50%;
    top: 50%;
    overflow:auto;
}
.d-cont > .body{
    position:relative;
    width:100%;
    height:100%;
}

.d-box{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    max-width:900px;
    width:98%;
    text-align:center;
}
.d-box > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-box > .body > .content{
    position: relative;
    padding: 20px;
    border: 5px solid #000000;
    margin-bottom: 20px;
    color: #000000;
    border-radius: 10px;
}

.d-box > .body > .footer{
    text-align:right;
}

.d-box-canvas{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    width:98%;
    text-align:center;
}
.d-box-canvas > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-box-canvas > .body > .content{
    position: relative;
    border: 5px solid #000000;
    margin-bottom: 20px;
    color: #000000;
    border-radius: 10px;
}

.d-box-canvas > .body > .footer{
    text-align:right;
}

.btn, .btn:active, .btn:focus{
    background-color: #dddddd !important;
    -webkit-box-shadow: 0 0 0 0 rgba(0,123,255,.25) !important;
    box-shadow: 0 0 0 0 rgba(0,123,255,.25) !important;
}

.d-ins{
    font-size:20px;
    text-align:left;
}

.d-ins .ins-img{
    width:auto;
    height:100px;
    margin:0px 10px;
}

.d-chart-box{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    max-width:900px;
    width:98%;
    text-align:center;
}
.d-chart-box > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-chart-box > .body > .content, .d-chart-box > .body > .chart{
    position:relative;
    padding:20px;
    border:5px solid #000000;
    margin-bottom:20px;
    color:#000000;
    border-radius: 10px;
    text-align:left;
}
.d-chart-box > .body > .chart{
    min-height: 350px;
}
#chart3,#chart4{
    height:290px;
    width:100%;
}

.d-chart-box > .body > .footer{
    text-align:right;
}

canvas{
    margin-bottom:10px;
}

.d-game{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    max-width:900px;
    width:98%;
    text-align:center;
}
.d-game > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-game > .body > .header{
    position: relative;
    padding: 20px;
    border: 5px solid #000000;
    margin-bottom: 20px;
    border-radius: 10px;
    font-size: 23px;
    font-weight: 700;
}
.d-game > .body > .target{
    position:relative;
    padding:20px;
    border:5px solid #000000;
    margin-bottom:20px;
    border-radius: 10px;
    height:auto;
    max-height: 500px;
    text-align: left;
}
.d-game > .body > .target > .content{
    position:relative;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    height:100%;
    width:100%;
    padding:10px;
    max-width:500px;
    max-height:200px;
}

.d-game > .body > .target > .content > img{
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%); 
    max-width:100%;
    max-height:100%;   
}

.d-game > .body > .target .d-countdown{
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%,-50%);
    font-size: 25px;
    width: 100%;
    padding: 10px;
}
.d-game > .body > .target .d-countdown > .title{
    font-weight:500;
}
.d-game > .body > .target .d-countdown > .count{
    font-weight:700;
    font-size:30px;
}

.d-game > .body > .footer{ 
    text-align:right; 
}
/* .d-game > .body > .footer > button{
    min-width:200px;
}  */
.d-notify{
    position: fixed;
    width: 100%;
    font-size: 35px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-weight: 500;
}


.d-cont.d-scroll{
    max-height: unset;
    position: absolute;
    transform: translate(-50%,0%);
    top: 0px;
    overflow:auto;
    width: 100%;
    max-width: unset;
}
.d-cont.d-scroll > .body{
    padding:10px;
}

.d-cont.d-scroll .d-box{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}
.d-cont.d-scroll .d-game{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}
.d-cont.d-scroll .d-box-canvas{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}
.d-cont.d-scroll .d-chart-box{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}



.d-progress{
    border: none;
    position: fixed;
    top: 0px;
    width: 100%;
    height: 5px;
    z-index:9999;
    background: #86888b;
}

.d-progress::-webkit-progress-value {
  background: #86888b;
}

.d-progress::-moz-progress-bar {
  background: #86888b;
}
.d-progress::-webkit-progress-value {
  background: #86888b;
}
.d-progress::-webkit-progress-bar {
  background: #dddddd;
}

.d-header {
    position: fixed;
    top: 0px;
    font-size: 30px;
    font-weight: 700;
    background: black;
    width: 100%;
    color: white;
    padding: 10px;
    text-align: center;
    z-index: 9998;
}


.d-wrong{
    color:rgba(0,0,0,.5);
}



.browserCont{
    position:relative;
    width:100%;
    text-align:center;
    margin:20px 0px;
}
.browserCont > .browser{
    position:relative;
    width:50px;
    height:auto;
    margin:10px;
}
.browserCont > .browser > img{
    width:50px;
    height:auto;
}

.col-md-4 > span {
  border: 1px solid #d2d2d2;
  padding: 0px 15px;
  font-weight: 700;
  cursor: pointer;
}

.col-md-4 > span.active {
  border: 2px solid red;
}

.my-textbox {
    max-width: 150px;
    margin-right: 5px;
    border: 1px solid #cecece;
}

.ans-drag {
  border: 1px solid #cecece;
  min-width: 130px;
  max-width: 150px;
  min-height: 25px;
  display: inline-block;
  vertical-align: middle;
}

.dragChoice {
  max-width: 500px;
  border: 2px solid #cecece;
  left: 50%;
  position: relative;
  transform: translate(-50%, 0px);
  margin-top: 3px;
  margin-bottom: 3px;
  min-height: 100px;
}

.col-md-6 > span {
  border: 1px solid #cecece;
  padding: 0px 15px;
  font-weight: 700;
}

.list-ans1-drag {
  text-align: center;
  font-weight: 700;
}

.errorShow {
    position: absolute;
    left: 50%;
    transform: translate(-69%, 0px);
    width: 100%;
    font-weight: 700;
}

.successShow {
    position: absolute;
    left: 50%;
    transform: translate(-73%, 0px);
    width: 100%;
    font-weight: 700;
}

em {
    font-size: 0.95rem;
}

@media only screen and (max-width: 1000px) {
    .d-ins .ins-img{
        width:auto;
        height:80px;
        margin:0px 5px;
    }  
    
    .d-game > .body > .header{
        padding: 10px;
        border: 5px solid #000000;
        margin-bottom: 10px;
        border-radius: 10px;
        font-size: 20px;
    }    
    .d-game > .body > .target {
        padding: 10px;
        border: 5px solid #000000;
        margin-bottom: 10px;
        max-height: unset;
    }   
    
}
@media only screen and (max-width: 780px) {
    .d-header {
        font-size: 0.9rem;
    }
    .content > h1 {
        font-size: 1.5rem;
    }
    .body > .header {
        font-size: 0.9rem;
    }
    .body > .target {
        font-size: 0.8rem;
    }
    .content > p, .content > ol > li {
        font-size: 0.8rem;
    }
    .content > div > div > p {
        font-size: 0.8rem;
    }
    .ans-drag {
        min-height: 23px;
        min-width:  115px;

    }
    .dragChoice {
        left: 45%;
        transform: translate(-40%, 0px);
    }
    .col-md-6 > span {
        font-size: 0.8rem;
    }
    .errorShow, .successShow {
        font-size: 0.55rem;
        text-align: left;
        width: 65%;
    }
}


</style>

